import React from 'react';

// Small hand-drawn icon set for travel-kit contents — no Lucide equivalents exist for these,
// so these are custom, matching Lucide's stroke-1.5 rounded-join convention for visual consistency.
const common = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function EyeMaskIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} {...common} {...props}>
      <path d="M2 10c1.5-1 3.5-1.5 5-1.5 2 0 3.2.9 5 .9s3-.9 5-.9c1.5 0 3.5.5 5 1.5" />
      <path d="M2 10c0 3 1.8 5 4.2 5 2.1 0 3.3-1.4 3.3-3.3" />
      <path d="M22 10c0 3-1.8 5-4.2 5-2.1 0-3.3-1.4-3.3-3.3" />
      <path d="M9.5 11.7h5" />
    </svg>
  );
}

export function EarplugsIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} {...common} {...props}>
      <ellipse cx="8" cy="12" rx="3.2" ry="4.2" />
      <ellipse cx="16" cy="12" rx="3.2" ry="4.2" />
    </svg>
  );
}

export function NeckPillowIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} {...common} {...props}>
      <path d="M6 4v6a6 6 0 0 0 12 0V4" />
      <path d="M6 10v6a2 2 0 0 0 2 2h1" />
      <path d="M18 10v6a2 2 0 0 1-2 2h-1" />
    </svg>
  );
}

export function SockIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} {...common} {...props}>
      <path d="M9 2h6v9.5c0 1 .4 2 1.2 2.7l2.6 2.4c.8.8 1.2 1.8 1.2 2.9V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6" />
      <path d="M9 2v13a2 2 0 0 1-2 2H5" />
    </svg>
  );
}

export function ToothbrushIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} {...common} {...props}>
      <path d="M3 21 14 10" />
      <path d="M13 6l5-3 3 3-3 5" />
      <path d="M11 8l5 5" />
      <path d="M9 10l5 5" />
    </svg>
  );
}
